export default __webpack_public_path__ + "static/media/pcp-guide-costs.926f8d6b.svg";